"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = Spinner;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["className", "color", "customSize", "size", "testId"];
var styles = {
  "Spinner": "Spinner__Spinner___32lpa",
  "Spinner--small": "Spinner__Spinner--small___2hyo0",
  "Spinner--large": "Spinner__Spinner--large___3TPiL",
  "Spinner--primary": "Spinner__Spinner--primary___SjakB",
  "Spinner--white": "Spinner__Spinner--white___3Hsq3",
  "circle1--translate": "Spinner__circle1--translate___1u68A",
  "circle1-translate": "Spinner__circle1-translate___3o4as",
  "circle1--scale": "Spinner__circle1--scale___38WqL",
  "circle1-scale": "Spinner__circle1-scale___3REbQ",
  "circle2--translate": "Spinner__circle2--translate___1GBUJ",
  "circle2-translate": "Spinner__circle2-translate___OKsXc",
  "circle2--scale": "Spinner__circle2--scale___3khDl",
  "circle2-scale": "Spinner__circle2-scale___vcBEG",
  "circle3--translate": "Spinner__circle3--translate___2M3jS",
  "circle3-translate": "Spinner__circle3-translate___2xnfV",
  "circle3--scale": "Spinner__circle3--scale___2zFhX",
  "circle3-scale": "Spinner__circle3-scale___2PKsS"
};

function Spinner(_ref) {
  var _cn;

  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'default' : _ref$color,
      customSize = _ref.customSize,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size,
      _ref$testId = _ref.testId,
      testId = _ref$testId === void 0 ? 'cf-ui-spinner' : _ref$testId,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classNames = (0, _classnames["default"])(styles.Spinner, className, (_cn = {}, (0, _defineProperty2["default"])(_cn, styles["Spinner--".concat(size)], size), (0, _defineProperty2["default"])(_cn, styles["Spinner--".concat(color)], color), _cn));
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 51",
    className: classNames,
    style: customSize ? {
      height: "".concat(customSize, "px"),
      width: "".concat(customSize, "px")
    } : {},
    "data-test-id": testId
  }, otherProps), /*#__PURE__*/_react["default"].createElement("title", null, "Loading\u2026"), /*#__PURE__*/_react["default"].createElement("g", {
    className: styles['circle1--translate'],
    transform: "translate(10,33.528168)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    className: styles['circle1--scale']
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    id: "circle1",
    r: "6",
    transform: "translate(0,10.471832)"
  }))), /*#__PURE__*/_react["default"].createElement("g", {
    className: styles['circle2--translate'],
    transform: "translate(30,33.528168)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    className: styles['circle2--scale']
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    id: "circle2",
    r: "6",
    transform: "translate(0,10.471832)"
  }))), /*#__PURE__*/_react["default"].createElement("g", {
    className: styles['circle3--translate'],
    transform: "translate(50,33.528168)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    className: styles['circle3--scale']
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    id: "circle3",
    r: "6",
    transform: "translate(0,10.471832)"
  }))));
}